import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';
import WhatshotIcon from '@material-ui/icons/BarChart';
import { useEffect, useState } from 'react';

const TotalEncoutners = (props) => {
  const [activeCount, setActiveCount] = useState(0);
  const { details } = props;
  useEffect(() => {
    if (details && details.length >= 0) {
      let r = 0;
      details.forEach(item => {
        // if (item.status === 1) {
        //   r++;
        // }
        r++;
      });
      setActiveCount(r);
    }
  }, [details]);

  return (
    <Card
      sx={{
        height: '100%',
        boxShadow: 12
      }}
      {...props}
    >
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'center' }}
        >
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: '#C43A75',
                height: 56,
                width: 56,
                
              }}
            >
              <WhatshotIcon />
            </Avatar>
          </Grid>
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              TOTAL ENCOUNTERS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
              sx={{ textAlign: 'center' }}
            >
              {activeCount}
            </Typography>
          </Grid>
          
        </Grid>
      </CardContent>
    </Card>
  )
};

export default TotalEncoutners;
